// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__2_IVp","input":"Checkbox_input__1gsjV","input--error":"Checkbox_input--error__1PMIX"};